module.exports = __webpack_public_path__ + "img/graph-paper-notebook_B099TG6Q7Q.02e7269e.jpg";